module.exports = __webpack_public_path__ + "img/cloth_g3_item-08.610a4512.svg";